export default "__VITE_ASSET__BknsXKHj__"